import type { LanguageCodeEnum } from '@/graphql/saleor/api';
import { fetchProductsBySkus } from '@/lib/product/api';

export const getTranslatedStrapNames = async (
  strapSkus: string[],
  languageCode: LanguageCodeEnum,
) => {
  const strapsData = await fetchProductsBySkus({
    skus: strapSkus,
    languageCode,
  });

  const strapNamesTranslated: { [sku: string]: string } = {};

  strapsData?.products?.edges.forEach((strap) => {
    const sku = strap.node.slug;
    const translatedStrapName =
      strap.node.strapName?.values[0].translation?.plainText ??
      strap.node.name ??
      '';
    if (sku && !strapNamesTranslated[sku]) {
      strapNamesTranslated[sku] = translatedStrapName;
    }
  });

  return strapNamesTranslated;
};
